import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, EnvironmentModel } from '@fh-client-interaction-frontends/fh-app-config';
import { HttpClient } from '@angular/common/http';
import { map, Observable, of } from 'rxjs';
import { SharedCountryListModel } from '../../helpers/objects/dto/shared-country-list/shared-country-list-model';
import { DropdownItemModel } from '@fh-client-interaction-frontends/fh-dropdown';

@Injectable({
  providedIn: 'root'
})
export class SharedCountryListService {
  appConfig: EnvironmentModel = new EnvironmentModel();
  cachedCountryList: SharedCountryListModel[] | null = null;
  cachedCountryPrefixList: DropdownItemModel[] = new Array<DropdownItemModel>();

  constructor(@Inject(APP_CONFIG) protected appConfigTemp: EnvironmentModel, private http: HttpClient) {
    this.appConfig = appConfigTemp;
  }

  get(): Observable<SharedCountryListModel[]> {
    return this.http.get<any>(this.appConfig.api + 'country-info').pipe(
      map((response) => {
        this.cachedCountryList = response.body.countries as SharedCountryListModel[];
        this.createCountryPrefixList(this.cachedCountryList);
        return this.cachedCountryList;
      })
    );
  }

  private createCountryPrefixList(countries: SharedCountryListModel[]): void {
    this.cachedCountryPrefixList = countries.map((item) => ({
      value: item.isoCode2,
      label: `<i class="fi fi-${item.isoCode2.toLowerCase()}"></i> ${item.designation} (${item.isoCode2})`,
      phonePrefix: item.phonePrefix
    }));
  }
}
